import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { DisableListTitle } from "../../../constants";
import { DisableListData, DisableListSubTitle } from "../../../data/uiKits/Lists";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const DisableList = () => {
  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={DisableListTitle} span={DisableListSubTitle} />
        <CardBody>
          <ListGroup>
            {DisableListData &&
              DisableListData.map((item, index) => (
                <ListGroupItem action className={`${item.class}`} key={index}>
                  <Image className="rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="user" />
                  {item.text}
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DisableList;
